import axios              from 'axios';
import walletUnlockHeader from 'services/wallet-unlock-header';

class PayoutMethodsService  {
  list() {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + 'payment/payout_methods', { headers: walletUnlockHeader() })
      .then(response => {
        return response.data;
      }
    );
  }

  create(parameters) {
    return axios
      .post(process.env.REACT_APP_API_ENDPOINT + 'payment/payout_methods', parameters, { headers: walletUnlockHeader() })
      .then(response => {
        return response.data;
      }
    );
  }

  delete(id) {
    return axios
      .delete(process.env.REACT_APP_API_ENDPOINT + 'payment/payout_methods/' + id, { headers: walletUnlockHeader() })
      .then(response => {
        return response.data;
      }
    );
  }
}

export default new PayoutMethodsService();
